import React, { useEffect, useState } from "react";
import { useSearcher } from "../../search/components/SearcherContext";
import { Dropdown, Form } from "semantic-ui-react";

function displayLocationName(obj) {
  return obj.LOCATION_NAME && obj.LOCATION_NAME[0];
}

const LocationSelector = ({ search, section, onChange }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    search.searchObjectTypes("", "location", { section }).then(({ hits }) =>
      setOptions(
        hits.map(obj => ({
          key: obj.ID[0],
          value: obj.ID[0],
          text: displayLocationName(obj)
        }))
      )
    );
  }, [search, section]);

  return (
    <Dropdown
      placeholder="Select a location"
      search
      fluid
      selection
      clearable
      onChange={(e, { value }) => onChange(value)}
      options={options}
    />
  );
};

export const LocationFacetFilter = ({ section, header }) => {
  const search = useSearcher();
  const onLocationChange = id => {
    search.addFilter([
      {
        filterId: null,
        filterType: "A",
        fieldName: "LOCATION",
        fieldValue: id
      }
    ]);
  };
  return (
    <Form.Field className="filter-field">
      {header}
      <LocationSelector
        search={search}
        section={section}
        onChange={onLocationChange}
      />
    </Form.Field>
  );
};

export default { Filter: LocationFacetFilter };
